// TermsAndPrivacy.js
import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/TermsAndPrivacy.css'; // external CSS file


const TermsAndPrivacy = () => {
  const { hash } = useLocation();

  // Scroll to the relevant section based on the hash in the URL
  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [hash]);

  return (
    <div className="terms-container">
      <p><Link to="/" className="terms-link">Return to Landing Page</Link></p>

      {/* Terms of Use Section */}
      <div id="terms" className="terms-section">
        <h2>Terms of Use</h2>
        <p><strong>Last updated:</strong> July 2, 2023</p>
        <p><strong>1. Acceptance of Terms</strong></p>
        <p>By accessing and using this website (the “Site”), you accept and agree to be bound by the terms and provisions of this agreement (the “Terms”). In addition, when using the Site’s particular services, you shall be subject to any posted guidelines or rules applicable to such services, which may be posted and modified from time to time. All such guidelines or rules are hereby incorporated by reference into the Terms.</p>
        
        <p><strong>2. Use of Site</strong></p>
        <p>This Site and its original content, features, and functionality are owned by Open Knowledge of New York LLC (OKNY) and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws. You agree to not engage in any activity that interferes with or disrupts the Services (or the servers and networks which are connected to the Services).</p>
        
        <p><strong>3. User Comments</strong></p>
        <p>You may post comments to blog articles. You are responsible for the content of your comments and any consequences that may arise from posting them. We reserve the right, but are not obligated, to monitor and edit or remove any comment. We take no responsibility and assume no liability for any comments posted by you or any third party.</p>
        
        <p><strong>4. Privacy</strong></p>
        <p>Your use of the Site is also subject to the Site’s Privacy Policy. Please review our Privacy Policy, which also governs the Site and informs users of our data collection practices.</p>
        
        <p><strong>5. Changes to the Terms</strong></p>
        <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide notice of any changes by posting the new Terms on this page. Changes to this Terms of Service are effective when they are posted on this page.</p>
        
        <p><strong>6. Termination</strong></p>
        <p>We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
        
        <p><strong>7. Contact Us</strong></p>
        <p>If you have any questions about these Terms, please contact us.</p>
      </div>

      {/* Privacy Policy Section */}
      <div id="privacy" className="terms-section">
        <h2>Privacy Policy</h2>
        <p><strong>Last updated:</strong> July 2, 2023</p>
        <p>At Open Knowledge of New York LLC (“we”, “us”, “our”), your privacy is a top priority. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website [www.okny.io] and use our services.</p>

        <p><strong>1. Information We Collect</strong></p>
        <p>We may collect and process the following types of information: Personal identification information including name, email, website, phone, IP address.</p>

        <p><strong>2. How We Use Your Information</strong></p>
        <p>We use the information we collect in various ways, including to: Provide, operate, and maintain our services; Improve, personalize, and expand our services.</p>

        <p><strong>3. Disclosure of Your Information</strong></p>
        <p>We may share your personal information in the following situations: With Service Providers: We may share your information with third-party vendors and service providers that provide services on our behalf.</p>

        <p><strong>4. Security of Your Information</strong></p>
        <p>We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable.</p>

        <p><strong>5. Cookies and Other Tracking Technologies</strong></p>
        <p>We may use cookies and similar tracking technologies to collect and store your information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.</p>

        <p><strong>6. Links to Other Sites</strong></p>
        <p>Our website may contain links to other websites that are not operated by us. If you click on a third-party link, you will be directed to that third party’s site. We strongly advise you to review the Privacy Policy of every site you visit.</p>

        <p><strong>7. Changes to This Privacy Policy</strong></p>
        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>

        <p><strong>8. Contact Us</strong></p>
        <p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.</p>
      </div>
    </div>
  );
};

export default TermsAndPrivacy;
